import { render, staticRenderFns } from "./CaseloadChartContainer.vue?vue&type=template&id=758c0e8c&scoped=true&"
import script from "./CaseloadChartContainer.vue?vue&type=script&lang=js&"
export * from "./CaseloadChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./CaseloadChartContainer.vue?vue&type=style&index=0&id=758c0e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c0e8c",
  null
  
)

export default component.exports